import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface MultiSelectorDialogItem {
    id: string;
    name: string;
}

export interface MultiSelectorDialogData {
    items: MultiSelectorDialogItem[];
    title: string;
    description: string;
    selectedItems: MultiSelectorDialogItem[];
    noDataMessage?: string;
}

@Component({
    selector: 'app-multi-selector-dialog',
    templateUrl: './multi-selector-dialog.component.html',
    styleUrls: ['./multi-selector-dialog.component.scss'],
})
export class MultiSelectorDialogComponent implements OnInit {
    items: MultiSelectorDialogItem[] = [];
    title: string;
    description: string;
    selectedItems: MultiSelectorDialogItem[] = [];
    noDataMessage: string;
    getSelectedItems() {}

    constructor(@Inject(MAT_DIALOG_DATA) data: MultiSelectorDialogData) {
        if (data) {
            this.title = data.title;
            this.items = data.items;
            this.description = data.description;
            this.selectedItems = data.selectedItems;

            this.noDataMessage = data.noDataMessage;
        }
    }

    ngOnInit(): void {}
}
